module.exports = __webpack_public_path__ + "img/arrow.46b12aa3.svg";